<template>
  <div class="sticky top-0">
    <div>
      <h1 class="title has-text-centered has-text-weight-medium has-background-white-ter">Cart</h1>
      <div id="cart_scroll_container"
        v-if="cartCount > 0"
        class="content is-medium margin-mobile sticky vh-80 enable-scroll overflow-x-hidden thin-scroll pr-5"
      >
      <div>
        <div v-for="item in items" :key="'cart_item_'+item.itemNumber">
          <div class="is-size-6 level is-mobile mb-0">
            <span class="level-left w-75">
              <span class="word-break-all">
                {{item.longName}}
                <span v-if="item.variantValues">{{variantName(item.variantValues)}}</span>
              </span>
            </span>
            <span class="level-right is-hidden">
              <button class="delete level-item" v-on:click="removeItem(item.itemNumber)"></button>
            </span>
          </div>
          <div class="is-size-6 level is-mobile mb-0">
            <span class="level-left w-60">
              <quantity-btn
                label="Add"
                fieldPlaceHolder="Quantity"
                btnCls="is-hidden"
                v-on:removeitem="removeItem(item.itemNumber)"
                fieldCls="border-box"
                v-model="item.quantity"
                class="level-left mr-5"
              ></quantity-btn>
            </span>
            <span class="level-right">
              <span class="level-item" v-html="formatPrice(item.itemPriceTotal)"></span>
            </span>
          </div>
          <div v-if="item.itemOptionList">
            <div v-for="(option, index) in item.itemOptionList" :key="'cart_item_'+item.itemNumber+'_option_'+option.uid+index">
              <div v-if="option.baseQty > 0" class="level is-mobile is-size-6">
                <span class="level-left">
                  <span class="level-item mr-5">{{option.quantity}} x</span>
                  <span class="level-item">{{option.name}}</span>
                </span>
                <span class="level-right" v-html="formatPrice(option.amount)" />
              </div>
            </div>
          </div>
          <div v-if="item.itemDiscountList">
            <div
              v-for="(disc, index) in item.itemDiscountList"
              :key="'cart_item_'+item.itemNumber+'_option_'+disc.discountId+index"
            >
              <div class="level is-mobile is-size-6" v-if="disc.amount">
                <span class="level-left">
                  <span class="level-item is-italic">{{ disc.discountCode }}</span>
                </span>
                <span class="level-right" v-html="formatPrice(disc.amount)" />
              </div>
            </div>
          </div>
        </div>
      </div>
        <div>
          <div
        v-if="!resourceId && deliveryInfo && applicableDeliveryModes && applicableDeliveryModes.length > 1"
        class="is-size-6 mt-5 mb-5"
      >
        <p class="buttons mt-5 is-centered">
          <button
            class="button is-inverted is-small"
            v-for="mode in applicableDeliveryModes"
            :key="mode"
            :class="[deliveryInfo.mode === mode? 'is-active is-focused is-info': '']"
            @click="updateDeliveryMode(mode)"
          >
            <span v-if="deliveryInfo.mode === mode" class="icon is-small">
              <font-awesome-icon icon="check" />
            </span>
            <span>{{ mode }}</span>
          </button>
        </p>
        <p class="help is-danger" v-if="errors && errors.deliveryModes">{{errors.deliveryModes.msg}}</p>
      </div>
      <div class="field mt-5">
          <div class="control">
            <textarea
              class="textarea is-small cart-note-vh"
              placeholder="Have any instructions to add?"
              v-model="note"
              maxlength="250"
            ></textarea>
          </div>
        </div>
        <div class="is-size-6 mt-5" v-if="cartCount > 0 && sale">
          <div class="has-text-weight-normal">
            <div>
              <span>Item Total</span>
              <span class="is-pulled-right" v-html="formatPrice(sale.billSubTotal)"></span>
            </div>
            <div v-if="sale.billDiscountTotal">
              <template v-for="disc in sale.billDiscountList">
                <div v-if="disc.amount" :key="disc.discountId">
                  <span>{{ disc.discountCode }}</span>
                  <span class="is-pulled-right" v-html="formatPrice(disc.amount)"></span>
                </div>
              </template>
            </div>
            <template v-if="sale.chargeList && sale.chargeList.length > 0">
              <div v-for="charge in sale.chargeList" :key="'charge_'+charge.chargeId">
                <span>{{ charge.name }}</span>
                <span class="is-pulled-right" v-html="formatPrice(charge.amount)"></span>
              </div>
            </template>
            <template v-if="sale.billTaxList && sale.billTaxList.length > 0">
              <div v-for="tax in sale.billTaxList" :key="'tax_'+tax.taxTypeId">
                <span>{{ tax.name }}</span>
                <span class="is-pulled-right" v-html="formatPrice(tax.amountExcluded)"></span>
              </div>
            </template>
          </div>
          <div class="is-size-5 has-text-weight-medium" id="cart_total">
            <span>Total</span>
            <span class="is-pulled-right" v-html="formatPrice(sale.billRoundedAmount)"></span>
          </div>
        </div>
        </div>
      </div>
      <p v-else class="has-text-centered">Empty cart</p>
    </div>
    <div class="padding-5 sticky cart-summary" id="cart_summary">
      <div class="buttons are-medium is-centered">
        <button class="button is-hidden-tablet mr-5" v-on:click="displayOutlet">
          <span class="icon is-small is-size-6">
            <font-awesome-icon icon="chevron-left" />
          </span>
          <span class="is-size-6">Back</span>
        </button>
        <!-- <a class="button is-link" v-on:click="$emit('displaybill')">
          <span class="icon is-small">
            <font-awesome-icon icon="receipt"/>
          </span>
          <span>
            Bill
          </span>
        </a>-->
        <button class="button is-primary" v-on:click="checkoutCart" v-if="cartCount > 0">
          <span class="icon is-small is-size-6" v-if="afterHoursPreOrder">
            <font-awesome-icon icon="clock" />
          </span>
          <span class="is-size-6">{{ orderNowLbl }}</span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Util from "@/util";
import Constants from "@/util/constants";
import quantityBtn from "@/components/ux/QuantityButton";

export default {
  name: "cart",
  components: {
    quantityBtn
  },

  data() {
    return {
      deliveryInfo: {},
      errors: {},
      displaySaleError: false,
      mapConfig: {},
      note: ""
    };
  },

  computed: {
    ...mapState("cart", ["items", "sale"]),
    ...mapState("business", ["resourceId", "features"]),
    ...mapState("user", ["currentLocation"]),
    ...mapGetters("business", ["deliveryModes", "deliveryModePreferences", "outletAddress", "isBizClosed"]),
    cartCount() {
      return this.items.length;
    },
    orderNowLbl() {
      const mode = this.deliveryInfo.mode
      let lbl = 'Order'
      switch (mode) {
        case Constants.dataMap.deliveryMode.DELIVERY:
          lbl = Constants.dataMap.deliveryModeLbl.DELIVERY
          break;
        case Constants.dataMap.deliveryMode.PICKUP:
          lbl = Constants.dataMap.deliveryModeLbl.PICKUP
          break;
      }
      return lbl
    },
    afterHoursPreOrder() {
      return this.isBizClosed && this.features.allowPreOrder
    },
    applicableDeliveryModes() {
      let dms = Util.cloneObj(this.deliveryModes)
      if (this.features.allowPreOrder && this.isBizClosed) {
        dms = dms.filter(mode => {
          return mode !== Constants.dataMap.deliveryMode.IN_STORE
        })
      }
      return dms
    }
  },

  created() {
    this.gmapInit()
  },

  mounted() {
    this.prepare();
  },

  activated() {
    this.prepare();
  },

  watch: {
    items: {
      handler: function() {
        this.updateSale();
      },
      deep: true
    },
    cartCount(count) {
      if (count !== 0) {
        return;
      }
      if (this.$route && this.$route.name.includes("Cart")) {
        this.displayOutlet();
      }
    },
    "errors.saleUIError"(error) {
      Util.notify(this, { error });
    },
    sale: {
      handler: function() {
        this.navigateToCartBottom()
      },
      deep: true
    }
  },

  methods: {
    prepare() {
      this.deliveryInfo = this.$store.getters["cart/deliveryInfo"];
    },

    removeItem(itemNumber) {
      this.$store.dispatch("cart/removeItem", itemNumber);
    },

    formatPrice(number) {
      return Util.formatPrice(number);
    },

    updateSale() {
      this.$store.dispatch("cart/updateSale");
    },

    displayOptions(item) {
      if (!item) {
        return false;
      }
      return !!item.itemOptionList.find(itemOption => itemOption.baseQty > 0);
    },

    variantName(variantValues) {
      return variantValues.map(vv => vv.value).join(" ");
    },

    updateDeliveryMode(mode) {
      this.deliveryInfo.mode = mode;
      this.$store.dispatch("cart/updateDeliveryInfo", this.deliveryInfo)
    },

    displayOutlet() {
      this.$router.go(-1);
    },

    checkoutCart() {
      this.validateSale();
      if (!Util.isEmpty(this.errors)) {
        this.displaySaleError = !this.displaySaleError;
        return;
      }
      this.$store.dispatch("user/isSignedIn", () => {
        this.$store.dispatch("cart/updateSaleField", {
          field: "note",
          value: this.note
        });
        this.$store.dispatch("cart/updateDeliveryInfo", this.deliveryInfo).then(() => {
          this.$store.dispatch('cart/fetchCustomerLoyaltyPoints').then(() => {
            this.$router.push({ name: "OutletCustomerForm" });
          });
        });
      });
    },

    isLocatedAtOutlet() {
      if (!this.currentLocation) {
        return true;
      }
      const { maxDistance = 0.1, distanceUnit = "km" } =
      this.mapConfig || {};
      const geolocation = this.outletAddress.geolocation;
      const coords = this.currentLocation.geolocation;

      let radius = maxDistance * 1000;
      if (distanceUnit === "mi") {
        radius = maxDistance * 1609.34;
      }

      const distanceFromOutlet = this.google.maps.geometry.spherical.computeDistanceBetween(
        new this.google.maps.LatLng(geolocation[1], geolocation[0]),
        new this.google.maps.LatLng(coords[1], coords[0])
      );

      if (distanceFromOutlet > radius) {
        return false;
      }
      return true;
    },

    validateSale() {
      let pref = {};
      const ignoreVal = !!this.resourceId;
      this.errors = {};

      if (ignoreVal) {
        if (!this.isLocatedAtOutlet()) {
          this.errors["saleUIError"] = {
            msg: "This order cannot be placed away from the outlet."
          };
        }
        return;
      }

      if (this.items.length === 0) {
        this.errors["deliveryModes"] = {
          msg: "Please review your order."
        };
      }

      if (
        this.deliveryModes &&
        this.deliveryModes.length > 0 &&
        !this.deliveryInfo.mode
      ) {
        this.errors["deliveryModes"] = {
          msg: "Please select mode of delivery."
        };
      } else {
        pref = this.deliveryModePreferences(this.deliveryInfo.mode);
        if (
          pref &&
          pref.minBillAmount &&
          this.sale.billRoundedAmount < pref.minBillAmount
        ) {
          this.errors["saleUIError"] = {
            msg: `Minimum order amount of ${this.formatPrice(
              pref.minBillAmount
            )} is required for ${this.deliveryInfo.mode}.`
          };
        }
      }
    },

    async gmapInit () {
      this.google = this.$gmapApi
    },

    navigateToCartBottom () {
      const cartList = document.getElementById('cart_scroll_container')

      if (cartList) {
        // cartList.scrollTop = cartList.clientHeight
        cartList.scrollTo(0, cartList.scrollHeight);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.w-60 {
  width: 60% !important;
}
.w-75 {
  width: 75% !important;
}
.mb-0 {
  margin-bottom: 0px !important;
}
.cart-note-vh {
  height: 8vh !important;
  min-height: 8vh !important;
  max-height: 8vh !important;
}
.cart-summary {
  bottom: 0px;
  z-index: 1;
}
</style>
